<ng-container *ngIf="!heColaborador">
  <div class="payment-container">
    <div class="payment-content">
      <!-- Título e Valor -->
      <div class="payment-header text-center mb-4">
        <h2 class="mb-3">Pagamento de Taxa de Adesão</h2>
        <div class="membership-fee">
          <h3>
            Taxa de Adesão:
            <span class="text-primary">{{ dadosProdutoVM && dadosProdutoVM.taxaAdesao | currency: 'BRL' }}</span>
          </h3>
          <small class="text-muted">*Parcela Única</small>
        </div>
      </div>

      <div
        *ngIf="dadosRecebidosDoBeneciarioVM && dadosRecebidosDoBeneciarioVM[0].dadosBeneficiario?.isGeia"
        class="payment-methods">
        <h4 class="mb-4">Selecione uma das Formas de Pagamento:</h4>
        <div class="row justify-content-center">
          <!-- Boleto -->
          <div class="col-md-3">
            <div
              class="payment-card box-shadow-5 round"
              (click)="!somenteLeituraStep && selecionarFormaPagamento(templateModal, _metodoPagamento.BOLETO)"
              [style.cursor]="somenteLeituraStep ? 'not-allowed !important;' : 'pointer'"
              [style.opacity]="somenteLeituraStep ? '0.4' : '1'">
              <div class="card h-100 shadow-sm">
                <div class="card-body text-center">
                  <img
                    src="../../../../../../assets/app-assets/images/proposta-externa/pagameto-icon/boleto.png"
                    alt="boleto"
                    class="mb-3"
                    style="height: 48px" />
                  <h5 class="card-title">Boleto</h5>
                </div>
              </div>
            </div>
          </div>

          <!-- Crédito -->
          <div class="col-md-3">
            <div
              class="payment-card box-shadow-5 round"
              (click)="!somenteLeituraStep && selecionarFormaPagamento(templateModal, _metodoPagamento.CREDITO)"
              [style.cursor]="somenteLeituraStep ? 'not-allowed !important;' : 'pointer'"
              [style.opacity]="somenteLeituraStep ? '0.4' : '1'">
              <div class="card h-100 shadow-sm">
                <div class="card-body text-center">
                  <img
                    src="../../../../../../assets/app-assets/images/proposta-externa/pagameto-icon/pagSeguro.png"
                    alt="creditoPagSeguro"
                    class="mb-3"
                    style="height: 48px" />
                  <h5 class="card-title">Crédito</h5>
                </div>
              </div>
            </div>
          </div>

          <!-- Transferência -->
          <div class="col-md-3">
            <div
              class="payment-card box-shadow-5 round"
              (click)="!somenteLeituraStep && selecionarFormaPagamento(templateModal, _metodoPagamento.TED)"
              [style.cursor]="somenteLeituraStep ? 'not-allowed !important;' : 'pointer'"
              [style.opacity]="somenteLeituraStep ? '0.4' : '1'">
              <div class="card h-100 shadow-sm">
                <div class="card-body text-center">
                  <img
                    src="../../../../../../assets/app-assets/images/proposta-externa/pagameto-icon/bb.png"
                    alt="bb"
                    class="mb-3"
                    style="height: 48px" />
                  <h5 class="card-title">Transferência</h5>
                </div>
              </div>
            </div>
          </div>

          <!-- PIX -->
          <div class="col-md-3">
            <div
              class="payment-card box-shadow-5 round"
              (click)="!somenteLeituraStep && selecionarFormaPagamento(templateModal, _metodoPagamento.PIX)"
              [style.cursor]="somenteLeituraStep ? 'not-allowed !important;' : 'pointer'"
              [style.opacity]="somenteLeituraStep ? '0.4' : '1'">
              <div class="card h-100 shadow-sm">
                <div class="card-body text-center">
                  <img
                    src="../../../../../../assets/app-assets/images/proposta-externa/pagameto-icon/pix.png"
                    alt="pix"
                    class="mb-3"
                    style="height: 48px" />
                  <h5 class="card-title">PIX</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <EXTENA -->
      <ng-container *ngIf="dadosRecebidosDoBeneciarioVM && !dadosRecebidosDoBeneciarioVM[0].dadosBeneficiario?.isGeia">
        <br />
        <div class="payment-header text-center mb-4">
          <h2 class="mb-3">
            ENTRE EM CONTATO COM O SEU CORRETOR
            <br />
            PARA EFETUAR O PAGAMENTO.
          </h2>
        </div>
      </ng-container>
      <!-- Mensagem Informativa -->
      <div class="text-center mt-4">
        <p class="text-muted">
          <small>Após o pagamento, iremos identificar em nosso sistema*</small>
        </p>
      </div>
      <!-- Botões de Ação -->
      <div class="d-flex justify-content-center gap-3 mt-4 action-buttons-container">
        <button class="btn btn-info round ml-2 box-shadow-5" (click)="clicarNaAba(propostaEnum.ANALISE)">
          ETAPA ANTERIOR
        </button>

        <button
          *ngIf="podeAnexarComprovante(dadosRecebidosDoBeneciarioVM)"
          class="btn btn-success round ml-2 box-shadow-5"
          (click)="!somenteLeituraStep && anexarComprovante(templateModalComprovante)"
          [disabled]="somenteLeituraStep"
          [style.cursor]="somenteLeituraStep ? 'not-allowed !important' : 'pointer'">
          ANEXAR COMPROVANTE
        </button>

        <!-- <button
          *ngIf="podeAnexarComprovante(dadosRecebidosDoBeneciarioVM)"
          class="btn btn-success round ml-2 box-shadow-5"
          (click)="anexarComprovante(templateModalComprovante)">
          ANEXAR COMPROVANTE
        </button> -->
      </div>
    </div>

    <!-- Painel Lateral -->
    <div class="side-panel round">
      <img
        src="../../../../../../assets/app-assets/images/proposta-externa/pagameto-icon/geia.png"
        alt="Geia"
        style="height: 87px !important; margin-left: 125px; margin-right: 100px" />

      <div class="product-summary round mt-5">
        <div class="product-item round" style="background-color: #fff; padding: 1rem">
          <h4 class="mb-4 text-bold-500">
            Seus Produtos
            <i class="fa fa-cart-plus"></i>
          </h4>
          <hr style="background-color: rgb(4, 4, 4); margin-bottom: 20px; margin-top: -43px !important" />
          <div class="product-details">
            <div class="detail-row">
              <span class="mr-1">Entidade:</span>
              <span class="font-size-text">{{ dadosProdutoVM && dadosProdutoVM.entidade }}</span>
            </div>
            <div class="detail-row">
              <span class="mr-1">Operadora:</span>
              <span class="font-size-text">{{ dadosProdutoVM && dadosProdutoVM.operadora }}</span>
            </div>
            <div class="detail-row">
              <span class="mr-1">Produto:</span>
              <span class="font-size-text">{{ dadosProdutoVM && dadosProdutoVM.nomeProduto }}</span>
            </div>
            <div class="detail-row">
              <span class="mr-1">Beneficiários Cadastrados:</span>
              <span class="font-size-text">{{ dadosProdutoVM && dadosProdutoVM.totalDependentes + 1 }}</span>
            </div>
            <div class="detail-row">
              <span class="mr-1">Cobertura:</span>
              <span class="font-size-text">{{ dadosProdutoVM && dadosProdutoVM.cobertura | uppercase }}</span>
            </div>
          </div>
        </div>

        <div style="background-color: #fff; padding: 1rem" class="round proposal-summary mt-4">
          <h4 class="mb-3 text-bold-500">
            Resumo da Proposta
            <i class="fa fa-file"></i>
          </h4>
          <hr style="background-color: rgb(4, 4, 4); margin-bottom: 20px; margin-top: -43px !important" />
          <div class="detail-row">
            <span>
              <i
                (click)="isExpanded = !isExpanded"
                class="cursor-pointer fa-1x"
                [ngClass]="isExpanded ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
              Total:
            </span>
            <span>{{ dadosProdutoVM && dadosProdutoVM.valorTotal | currency: 'BRL' }}</span>
          </div>
          <div *ngIf="isExpanded" class="expanded-details">
            <div class="detail-row">
              <span>Titular:</span>
              <span>{{ dadosProdutoVM && dadosProdutoVM.valorTitular | currency: 'BRL' }}</span>
            </div>
            <div class="detail-row">
              <span>Dependente(s):</span>
              <span>{{ calcularTotalDependentes() | currency: 'BRL' }}</span>
            </div>

            <div class="detail-row">
              <strong>Total:</strong>
              <span>{{ dadosProdutoVM && dadosProdutoVM.valorTotal | currency: 'BRL' }}</span>
            </div>
          </div>
          <div class="detail-row">
            <span>Taxa de adesão:</span>
            <span>{{ dadosProdutoVM && dadosProdutoVM.taxaAdesao | currency: 'BRL' }} *única</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- botes formas pagamento -->
  <ng-template #templateModal>
    <div class="modal-header {{ classTipoModal }}">
      <img
        *ngIf="ehCredito"
        src="../../../../../../assets/app-assets/images/proposta-externa/pagameto-icon/pagSeguro.png"
        alt="creditoPagSeguro"
        class=""
        style="margin-left: 39%; width: 15% !important" />
      <img
        *ngIf="ehBB"
        src="../../../../../../assets/app-assets/images/proposta-externa/pagameto-icon/bb.png"
        alt="banco Brasil"
        class=""
        style="margin-left: 39%; width: 15% !important" />
      <img
        *ngIf="ehPIX"
        src="../../../../../../assets/app-assets/images/proposta-externa/pagameto-icon/pix.png"
        alt="PIX"
        class=""
        style="margin-left: 39%; width: 15% !important" />
      <img
        *ngIf="ehBoleto"
        src="../../../../../../assets/app-assets/images/proposta-externa/pagameto-icon/boleto.png"
        alt="Boleto"
        class=""
        style="margin-left: 39%; width: 15% !important" />
      <button (click)="fecharModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div class="row">
        <div class="col-md-12 text-center">
          <h4 class="text-center text-bold-600 mt-1 mb-1">GEIA ADMINISTRADORA DE BENEFICIOS</h4>
          <h4 class="text-center text-bold-600 mb-2">CNPJ: 07.867.825/0001-57</h4>
          <h3 class="text-center text-bold-500 mt-1 mb-2">
            <span class="text-primary">{{ dadosProdutoVM && dadosProdutoVM.taxaAdesao | currency: 'BRL' }}</span>
          </h3>
        </div>
      </div>

      <div *ngIf="ehCredito" class="credit-card-container">
        <!-- Card Card -->
        <div class="card-container">
          <div class="credit-card" [class.flipped]="isFlipped">
            <!-- Frente do Cartão -->
            <div class="card-front">
              <!-- Chip Row -->
              <img
                class="chip-icon"
                alt="Chip"
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/0d/Icons8_flat_sim_card_chip.svg/512px-Icons8_flat_sim_card_chip.svg.png" />
              <!-- Number Row -->
              <div class="card-number-section">
                <label class="card-label">Número do Cartão</label>
                <div class="card-number">
                  {{ formatCardNumber(cardFormCredito.get('cardNumber')?.value || '') || '1234 5678 9876 5643' }}
                </div>
              </div>
              <!-- Card Holder -->
              <div class="card-holder-section">
                <label class="card-label">Nome</label>
                <div class="card-holder">
                  {{ cardFormCredito.get('holderName')?.value || 'Fulano de Tal' }}
                </div>
              </div>
              <!-- Expiry Date -->
              <div class="card-expiry-section">
                <label class="card-label">Validade</label>
                <div class="card-expiry">
                  {{ formatExpiry(cardFormCredito.get('expiry')?.value || '') || '02/2032' }}
                </div>
              </div>
            </div>
            <!-- Verso do Cartão -->
            <div class="card-back">
              <div class="card-stripe"></div>
              <div class="card-cvv-section">
                <label class="card-label">Código(CVV)</label>
                <div class="card-cvv mt-1">
                  {{ cardFormCredito.get('securityCode')?.value || 'XXX' }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <form [formGroup]="cardFormCredito" class="row col-md-12">
          <div class="form-row">
            <div class="form-group col-md-6">
              <label>Número do Cartão</label>
              <input
                type="text"
                placeholder="XXXX XXXX XXXX XXXX"
                [mask]="'0000 0000 0000 0000||0000 000000 00000'"
                [dropSpecialCharacters]="false"
                formControlName="cardNumber"
                class="form-control border-radius"
                [ngClass]="{
                  'is-invalid': cardFormCredito.controls['cardNumber'].errors && isFormSubmited
                }" />
              <app-validacao-form-input
                [nomeFormulario]="cardFormCredito"
                nomeCampo="cardNumber"
                [maxLength]="16"
                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
              <div
                *ngIf="
                  cardFormCredito.get('cardNumber') &&
                  cardFormCredito.get('cardNumber')?.hasError('numeroInvalido') &&
                  (cardFormCredito.get('cardNumber')?.touched || cardFormCredito.get('cardNumber')?.dirty)
                ">
                <small class="text-danger">Número do cartão de crédito inválido.</small>
              </div>
            </div>

            <div class="form-group col-md-6">
              <label>Titular</label>
              <input
                type="text"
                maxlength="23"
                (keypress)="onlyLettersAndSpaces($event)"
                formControlName="holderName"
                class="form-control border-radius"
                placeholder="Fulano de Tal"
                [ngClass]="{
                  'is-invalid': cardFormCredito.controls['holderName'].errors && isFormSubmited
                }" />
              <app-validacao-form-input
                [nomeFormulario]="cardFormCredito"
                nomeCampo="holderName"
                [maxLength]="23"
                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
              <div
                *ngIf="
                  cardFormCredito.get('holderName')?.invalid &&
                  (cardFormCredito.get('holderName')?.touched || cardFormCredito.get('holderName')?.dirty)
                ">
                <small class="text-danger">O nome deve conter apenas letras.</small>
              </div>
            </div>

            <div class="form-group col-md-6">
              <label>Validade(MM/AAAA)</label>
              <input
                type="text"
                mask="M0/0000"
                formControlName="expiry"
                class="form-control border-radius"
                placeholder="MM/YYYY"
                minlength="6"
                maxlength="7"
                [ngClass]="{
                  'is-invalid': cardFormCredito.controls['expiry'].errors && isFormSubmited
                }" />
              <app-validacao-form-input
                [nomeFormulario]="cardFormCredito"
                nomeCampo="expiry"
                [maxLength]="7"
                [minLength]="6"
                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
            </div>

            <div class="form-group col-md-6">
              <label>Código(CVV)</label>
              <input
                type="text"
                formControlName="securityCode"
                class="form-control border-radius"
                placeholder="XXX"
                maxlength="3"
                minlength="3"
                mask="000"
                (focus)="isFlipped = true"
                (blur)="isFlipped = false"
                [ngClass]="{
                  'is-invalid': cardFormCredito.controls['securityCode'].errors && isFormSubmited
                }" />
              <app-validacao-form-input
                [nomeFormulario]="cardFormCredito"
                nomeCampo="securityCode"
                [maxLength]="3"
                [minLength]="3"
                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
            </div>

            <div class="form-group col-md-6">
              <label>CPF</label>
              <input
                type="text"
                formControlName="cpfHolder"
                class="form-control border-radius"
                placeholder="xxx xxx xxx xx"
                mask="000.000.000-00"
                [ngClass]="{
                  'is-invalid': cardFormCredito.controls['cpfHolder'].errors && isFormSubmited
                }" />
              <app-validacao-form-input
                [nomeFormulario]="cardFormCredito"
                nomeCampo="cpfHolder"
                [maxLength]="14"
                [minLength]="11"
                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
            </div>

            <div class="form-group col-md-6">
              <label>Parcelas</label>

              <ng-select
                style="min-width: 29% !important; background-color: #407590"
                class="round shadow"
                id="installments"
                formControlName="installments"
                [multiple]="false"
                [loading]="false"
                [closeOnSelect]="true"
                [searchable]="true"
                required
                [ngClass]="{
                  'is-invalid': cardFormCredito.controls['installments'].errors && isFormSubmited
                }">
                <ng-option *ngFor="let option of _listaParcelasCartaoCredito" [value]="option.value">
                  {{ option.label }}
                </ng-option>
              </ng-select>

              <app-validacao-form-input
                [nomeFormulario]="cardFormCredito"
                nomeCampo="installments"
                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
            </div>
          </div>
        </form>
      </div>

      <div *ngIf="ehBoleto" id="section-boleto" class="credit-card-container" style="margin: -5px !important">
        <label style="font-size: 1em; margin-bottom: -11px">Recibo do Pagador</label>

        <!-- DADOS DO RECIB INICIO -->
        <div class="boleto">
          <div class="boleto-header">
            <div class="banco-info">
              <img
                src="../../../../../../assets/app-assets/images/proposta-externa/pagameto-icon/logo-itau.png"
                alt="Itaú" />
              <span class="banco-nome">Banco Itaú S.A.</span>
            </div>

            <!-- Código do banco -->
            <div class="codigo-banco">341-7</div>

            <!-- Linha digitável -->
            <div class="linha-digitavel">{{ formatarLinhaDigitavel(dadosBoleto?.linhaDigitavel) }}</div>
          </div>

          <div class="linha">
            <div class="campo grande">
              <span><strong>BOLETO DE PROPOSTA</strong></span>
              <p>
                <strong>
                  ESTE BOLETO SE REFERE A UMA PROPOSTA JÁ FEITA A VOCÊ E O SEU PAGAMENTO NÃO É OBRIGATÓRIO.
                </strong>
                <br />
                Deixar de pagá-lo não dará causa a proposta, a cobrança judicial ou extrajudicial, nem inserção de seu
                nome em cadastro de restrição ao crédito. Pagar até o vencimento significa aceitar a proposta.
                Informações adicionais sobre a proposta e sobre o respectivo contrato poderão ser solicitadas a qualquer
                momento ao beneficiário, por meio de seus canais de atendimento.
              </p>
            </div>
          </div>

          <div class="linha">
            <div class="campo grande">
              <strong>Local de Pagamento</strong>
              <span class="text-uppercase">Pagável em qualquer banco ou correspondente até a data de vencimento</span>
              <strong class="text-uppercase">Não Pagável após a data de vencimento</strong>
            </div>
            <div class="campo pequeno">
              <strong>Data de Vencimento</strong>
              <span>{{ dadosBoleto?.dataVencimento | date: 'dd/MM/yyyy' }}</span>
            </div>
          </div>
          <div class="linha">
            <div class="campo grande">
              <strong>Nome do Beneficiário, CPF/CNPJ/Endereço</strong>
              <span>{{ dadosBoleto?.cedenteNome }}</span>
              <span>| {{ dadosBoleto?.cedenteDocumento | mask: '000.000.000-00||00.000.000/0000-00' }} |</span>
              <span>RUA VALDEMAR FERREIRA, 463 - SÃO PAULO - SP</span>
            </div>

            <div class="campo">
              <strong>Agéncia/Código beneficiário</strong>
              <span>0383/88719-7</span>
            </div>
          </div>
          <div class="linha">
            <div class="campo pequeno">
              <strong>Data do documento</strong>
              <span>{{ dadosBoleto?.dataEmissao | date: 'dd/MM/yyyy' }}</span>
            </div>
            <div class="campo pequeno">
              <strong>Nº documento</strong>
              <span>{{ dadosBoleto?.numeroDocumento }}</span>
            </div>
            <div class="campo pequeno">
              <strong>Espécie Doc.</strong>
              <span>BDP</span>
            </div>
            <div class="campo pequeno">
              <strong>Aceite</strong>
              <span>N</span>
            </div>
            <div class="campo pequeno">
              <strong>Data Processamento</strong>
              <span>{{ dadosBoleto?.dataEmissao | date: 'dd/MM/yyyy' }}</span>
            </div>
            <div class="campo pequeno">
              <strong>Nosso Número</strong>
              <span>{{ dadosBoleto?.nossoNumero | mask: '000/00000000-0' }}</span>
            </div>
          </div>

          <div class="linha">
            <div class="campo">
              <strong>Uso do banco</strong>
              <span></span>
            </div>

            <div class="campo">
              <strong class="bold">Carteira</strong>
              <span>{{ dadosBoleto?.carteira }}</span>
            </div>
            <div class="campo">
              <strong class="bold">Espécie</strong>
              <span>R$</span>
            </div>
            <div class="campo">
              <strong class="bold">Quantidade</strong>
              <span></span>
            </div>
            <div class="campo">
              <strong class="bold">Valor</strong>
              <span></span>
            </div>
            <div class="campo">
              <strong class="bold">(=)Valor do documento</strong>
              <span>{{ dadosBoleto?.membershipFee.value | currency: 'BRL' }}</span>
            </div>
          </div>

          <div class="linha">
            <div class="campo grande">
              <strong>Instruções</strong>
              {{ dadosBoleto?.instrucoes }}
            </div>
            <div class="campo">
              <span class="bold">(-)Descontos/Abatimento</span>
              <br />
              <span class="bold">(=)Valor cobrado</span>
            </div>
          </div>

          <div class="linha">
            <div class="campo grande">
              <span class="bold">Nome do Pagador: {{ dadosBoleto?.sacadoNome }}</span>
              <span class="bold">
                Endereço: {{ dadosBoleto?.sacadoEndereco }},{{ dadosBoleto?.sacadoBairro }},
                {{ dadosBoleto?.sacadoCidadeUf }}|{{ dadosBoleto?.sacadoCep | mask: '00000-000' }}
              </span>
              <span class="bold">Sacador/Avalista:</span>
            </div>
          </div>
        </div>
        <label style="margin-left: 508px; margin-top: -16px; font-weight: 500; margin-bottom: -20px">
          Autenticação Mecânica
        </label>

        <!-- DADOS DO RECIB FIM -->

        <div>
          <label>
            -----------------------------------------------------------------------------------------------------------------
            <i class="mr-2 fa fa-cut"></i>
          </label>
        </div>
        <br />
        <div class="boleto">
          <div class="boleto-header">
            <div class="banco-info">
              <img
                src="../../../../../../assets/app-assets/images/proposta-externa/pagameto-icon/logo-itau.png"
                alt="Itaú" />
              <span class="banco-nome">Banco Itaú S.A.</span>
            </div>

            <!-- Código do banco -->
            <div class="codigo-banco">341-7</div>

            <!-- Linha digitável -->
            <div class="linha-digitavel">{{ formatarLinhaDigitavel(dadosBoleto?.linhaDigitavel) }}</div>
          </div>

          <div class="linha">
            <div class="campo grande">
              <span><strong>BOLETO DE PROPOSTA</strong></span>
              <p>
                <strong>
                  ESTE BOLETO SE REFERE A UMA PROPOSTA JÁ FEITA A VOCÊ E O SEU PAGAMENTO NÃO É OBRIGATÓRIO.
                </strong>
                <br />
                Deixar de pagá-lo não dará causa a proposta, a cobrança judicial ou extrajudicial, nem inserção de seu
                nome em cadastro de restrição ao crédito. Pagar até o vencimento significa aceitar a proposta.
                Informações adicionais sobre a proposta e sobre o respectivo contrato poderão ser solicitadas a qualquer
                momento ao beneficiário, por meio de seus canais de atendimento.
              </p>
            </div>
          </div>

          <div class="linha">
            <div class="campo grande">
              <strong>Local de Pagamento</strong>
              <span class="text-uppercase">Pagável em qualquer banco ou correspondente até a data de vencimento</span>
              <strong class="text-uppercase">Não Pagável após a data de vencimento</strong>
            </div>
            <div class="campo pequeno">
              <strong>Data de Vencimento</strong>
              <span>{{ dadosBoleto?.dataVencimento | date: 'dd/MM/yyyy' }}</span>
            </div>
          </div>
          <div class="linha">
            <div class="campo grande">
              <strong>Nome do Beneficiário, CPF/CNPJ/Endereço</strong>
              <span>{{ dadosBoleto?.cedenteNome }}</span>
              <span>| {{ dadosBoleto?.cedenteDocumento | mask: '000.000.000-00||00.000.000/0000-00' }} |</span>
              <span>RUA VALDEMAR FERREIRA, 463 - SÃO PAULO - SP</span>
            </div>

            <div class="campo">
              <strong>Agéncia/Código beneficiário</strong>
              <span>0383/88719-7</span>
            </div>
          </div>
          <div class="linha">
            <div class="campo pequeno">
              <strong>Data do documento</strong>
              <span>{{ dadosBoleto?.dataEmissao | date: 'dd/MM/yyyy' }}</span>
            </div>
            <div class="campo pequeno">
              <strong>Nº documento</strong>
              <span>{{ dadosBoleto?.numeroDocumento }}</span>
            </div>
            <div class="campo pequeno">
              <strong>Espécie Doc.</strong>
              <span>BDP</span>
            </div>
            <div class="campo pequeno">
              <strong>Aceite</strong>
              <span>N</span>
            </div>
            <div class="campo pequeno">
              <strong>Data Processamento</strong>
              <span>{{ dadosBoleto?.dataEmissao | date: 'dd/MM/yyyy' }}</span>
            </div>
            <div class="campo pequeno">
              <strong>Nosso Número</strong>
              <span>{{ dadosBoleto?.nossoNumero | mask: '000/00000000-0' }}</span>
            </div>
          </div>

          <div class="linha">
            <div class="campo">
              <strong>Uso do banco</strong>
              <span></span>
            </div>

            <div class="campo">
              <strong class="bold">Carteira</strong>
              <span>{{ dadosBoleto?.carteira }}</span>
            </div>
            <div class="campo">
              <strong class="bold">Espécie</strong>
              <span>R$</span>
            </div>
            <div class="campo">
              <strong class="bold">Quantidade</strong>
              <span></span>
            </div>
            <div class="campo">
              <strong class="bold">Valor</strong>
              <span></span>
            </div>
            <div class="campo">
              <strong class="bold">(=)Valor do documento</strong>
              <span>{{ dadosBoleto?.membershipFee.value | currency: 'BRL' }}</span>
            </div>
          </div>

          <div class="linha">
            <div class="campo grande">
              <strong>Instruções</strong>
              {{ dadosBoleto?.instrucoes }}
            </div>
            <div class="campo">
              <span class="bold">(-)Descontos/Abatimento</span>
              <br />
              <span class="bold">(=)Valor cobrado</span>
            </div>
          </div>

          <div class="linha">
            <div class="campo grande">
              <span class="bold">Nome do Pagador: {{ dadosBoleto?.sacadoNome }}</span>
              <span class="bold">
                Endereço: {{ dadosBoleto?.sacadoEndereco }}|{{ dadosBoleto?.sacadoBairro }},
                {{ dadosBoleto?.sacadoCidadeUf }},{{ dadosBoleto?.sacadoCep | mask: '00000-000' }}
              </span>
              <span class="bold">Sacador/Avalista:</span>
            </div>
          </div>
          <!-- Código de barras -->
          <div class="linha barras">
            <div class="codigo-barras">
              <svg id="barcode"></svg>
            </div>
          </div>
        </div>
      </div>
      <!-- BANCO BRASIL -->

      <div *ngIf="ehBB" class="card-body row justify-content-center">
        <div class="card-block">
          <fieldset>
            <div class="input-group input-group-lg">
              <div class="input-group-prepend">
                <span
                  style="border-radius: 30px 2px 0px 30px; background-color: #505efc; border-radius: 30px 2px 0px 30px"
                  class="text-white input-group-text"
                  id="sizing-addon3">
                  Agência:
                </span>
              </div>
              <input
                readonly
                style="
                  padding: 1rem !important;
                  font-size: 2rem !important;
                  width: 50% !important;
                  border-radius: 2px 25px 26px 1px !important;
                "
                value="1195-9"
                type="text"
                class="form-control border-radius"
                placeholder="1195-9"
                aria-describedby="sizing-addon3" />
            </div>

            <div class="input-group input-group-lg mt-3">
              <div class="input-group-prepend">
                <span
                  style="border-radius: 30px 2px 0px 30px; background-color: #505efc; border-radius: 30px 2px 0px 30px"
                  class="text-white input-group-text"
                  id="sizing-addon3">
                  Conta:
                </span>
              </div>
              <input
                readonly
                style="
                  padding: 1rem !important;
                  font-size: 2rem !important;
                  width: 50% !important;
                  border-radius: 2px 25px 26px 1px !important;
                "
                type="text"
                class="form-control border-radius"
                placeholder="108192-6"
                value="108192-6"
                aria-describedby="sizing-addon3" />
            </div>
          </fieldset>
        </div>
      </div>
      <!-- PIX -->
      <div *ngIf="ehPIX" class="card-body row justify-content-center">
        <div class="card-block">
          <fieldset>
            <div class="input-group input-group-lg">
              <div class="input-group-prepend">
                <span class="text-white input-group-text input-span-cnpj" id="sizing-addon3">Chave PIX(CNPJ):</span>
              </div>
              <input
                readonly
                value="07.867.825/0001-57"
                type="text"
                class="form-control border-radius input-cnpj"
                placeholder="07.867.825/0001-57"
                aria-describedby="sizing-addon3" />
            </div>
          </fieldset>
          <br />
          <!-- <span class="text-center cursor-pointer"
          ><a>Copiar Chave <i class="fa fa-copy"></i></a
          ></span> -->
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="button-mobile d-flex justify-content-between mt-3">
        <button class="btn btn-warning round ml-2 box-shadow-5" (click)="fecharModal()">
          <i class="fa fa-times"></i>
          Fechar
        </button>
        <ng-container *ngIf="ehBoleto">
          <button class="btn btn-success round ml-2 box-shadow-5" (click)="imprimirBoleto()">
            <i class="fa fa-print"></i>
            Imprimir Boleto
          </button>
        </ng-container>

        <ng-container *ngIf="ehCredito">
          <app-geia-button
            type="success"
            label="Concluir Pagamento"
            icon="fa fa-check"
            (click)="concluirPagamento()"
            extraClass="round ml-2"></app-geia-button>
        </ng-container>
      </div>
    </div>
  </ng-template>

  <!-- UPLOAD -->
  <ng-template #templateModalComprovante>
    <div class="modal-header bg bg-info">
      <h5 class="modal-title white title-modal">Anexar comprovante de pagamento</h5>
      <button (click)="fecharModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body text-center container"></div>
    <div class="container-fluid text-justify">
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <div class="upload text-justify">
              <div class="custom-file-upload input-group">
                <input
                  style="height: 41px !important"
                  id="inputDocumentoUpload"
                  placeholder="Selecione um documento."
                  class="form-control"
                  readonly
                  type="file"
                  (change)="uploadDocumento($event)" />

                <hr />
              </div>
            </div>

            <div
              *ngIf="mensgemTemporaria"
              class="alert round alert-icon-left alert-arrow-left alert-info alert-dismissible mb-2"
              role="alert">
              <span class="alert-icon"><i class="fa fa-1x fa-exclamation-triangle"></i></span>

              <strong>{{ mensgemTemporaria }}</strong>
            </div>
            <p class="mt-2 text-justify">
              <strong>Instruções de Envio:</strong>
            </p>
            <ul>
              <li>Formatos permitidos: JPG, PNG, PDF</li>
              <li>Tamanho máximo: 5 MB</li>
              <li>Certifique-se de que o arquivo esteja claro e legível</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <app-geia-button
        type="info"
        label="Fechar"
        icon="fa fa-times"
        (onClick)="fecharModal()"
        extraClass="round"></app-geia-button>

      <app-geia-button
        type="success"
        label="Enviar comprovante"
        icon="fa fa-send "
        extraClass="round"
        (onClick)="enviarArquivoUploaded()"></app-geia-button>
    </div>
  </ng-template>
</ng-container>

<ng-container *ngIf="heColaborador">
  <app-proposta-pagamento-colaborador
    [dadosBeneficiario]="dadosRecebidosDoBeneciarioVM"></app-proposta-pagamento-colaborador>
</ng-container>
<!-- Botão para abrir o modal documento final -->
<!-- <button class="btn btn-primary" (click)="abrirModalDocumentoFinal()">
  <i class="fa fa-arrow-right"></i> abrilModalAditivo
</button> -->
<ng-template #modalDocFinal let-modal>
  <div>
    <div class="modal-body">
      <ng-container *ngIf="heOdonto">
        <ng-container *ngIf="entidades.heOdontoPrev">
          <app-documentos-proposta-externa-OdontoPrev
            [dadosOperadoraDM]="dadosOperadoraDM"
            [idProposta]="idProposta"></app-documentos-proposta-externa-OdontoPrev>
        </ng-container>

        <ng-container *ngIf="entidades.heUnimedOdonto">
          <app-documentos-proposta-externa-unimedOdonto
            [dadosOperadoraDM]="dadosOperadoraDM"
            [idProposta]="idProposta"></app-documentos-proposta-externa-unimedOdonto>
        </ng-container>

        <ng-container *ngIf="entidades.heUniOdonto">
          <app-documentos-proposta-externa-uniodonto
            [dadosOperadoraDM]="dadosOperadoraDM"
            [idProposta]="idProposta"></app-documentos-proposta-externa-uniodonto>
        </ng-container>
      </ng-container>

      <!-- SAUDE -->
      <ng-container *ngIf="!heOdonto">
        <ng-container *ngIf="entidades.heUnimedFesp">
          <app-documento-unimed-fesp-proposta
            [dadosOperadoraDM]="dadosOperadoraDM"
            [idProposta]="idProposta"
            [listaBeneficiarioDSSelecionados]="listaIdBeneficiarios"></app-documento-unimed-fesp-proposta>
        </ng-container>

        <ng-container *ngIf="entidades.heUdemo">
          <app-proposta-documento-final-udemo
            [dadosOperadoraDM]="dadosOperadoraDM"
            [idProposta]="idProposta"
            [listaBeneficiarioDSSelecionados]="listaIdBeneficiarios"></app-proposta-documento-final-udemo>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <!-- Buttons -->
  <div class="row">
    <div class="mb-1 mt-1 ml-5">
      <input [(ngModel)]="checkboxDocFinal" id="checkboxDocFinal" type="checkbox" />
      <label class="termo-aceite bold alinhamento-texto-check-box" for="checkboxDocFinal">
        Li e concordo com o documento
        <a class="ml-1"></a>
      </label>
    </div>
  </div>
  <div class="modal-footer">
    <app-geia-button
      [disabled]="!checkboxDocFinal"
      type="geia-blue"
      label="Assinar e Avançar"
      icon="fa fa-check "
      extraClass="round"
      (onClick)="assinarDocFinal()"></app-geia-button>
  </div>
</ng-template>
